import { handleActions, combineActions } from 'redux-actions';
import { LOAD_AVATARS } from '../constants';

const initialState = {
  error: false,
  loading: false,
  data: null,
  response: null,
};

const avatarsReducer = handleActions(
  {
    [combineActions(
      LOAD_AVATARS.CANCELLED,
      LOAD_AVATARS.ERROR,
      LOAD_AVATARS.SUCCESS,
    )]: state => ({ ...state, loading: false }),
    [LOAD_AVATARS.ERROR]: (state, { payload }) => ({
      ...state,
      error: true,
      response: payload,
    }),
    [LOAD_AVATARS.SUCCESS]: (state, { payload }) => ({
      ...state,
      error: false,
      response: null,
      data: payload,
    }),
    [LOAD_AVATARS.CLEAR]: state => ({
      ...state,
      error: false,
      response: null,
    }),
  },
  initialState,
);

export default avatarsReducer;
